import React, { Suspense } from 'react';
import styled from 'styled-components';

const BankLogosMarquee = React.lazy(() =>
  import('src/components/modals/post-signup-bank-link/components/bank-logos-marquee').then((module) => ({
    default: module.BankLogosMarquee,
  }))
);

type SignupLogoMarqueeProps = {
  dispensaryLogo: string | null;
  dispensaryName: string;
};

export function SignupLogoMarquee({ dispensaryLogo, dispensaryName }: SignupLogoMarqueeProps): JSX.Element {
  return (
    <Wrapper>
      <MarqueeTrack aria-hidden='true' data-testid='pbb-signup-bank-marquee'>
        <Suspense fallback={null}>
          <BankLogosMarquee />
        </Suspense>
      </MarqueeTrack>
      {dispensaryLogo && (
        <LogoCard>
          <LogoImageContainer>
            <LogoImage src={dispensaryLogo} alt={`${dispensaryName} Logo`} />
          </LogoImageContainer>
        </LogoCard>
      )}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  align-items: center;
  display: flex;
  isolation: isolate;
  justify-content: center;
  min-height: 96px;
  position: relative;
  width: 100%;
`;

const MarqueeTrack = styled.div`
  height: 48px;
  left: 50%;
  mask-image: linear-gradient(to right, transparent 0%, #000 40%, #000 60%, transparent 100%);
  -webkit-mask-image: linear-gradient(to right, transparent 0%, #000 40%, #000 60%, transparent 100%);
  overflow: hidden;
  pointer-events: none;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  z-index: 1;
`;

const LogoCard = styled.div`
  align-items: center;
  background: var(--dcm-pbb-logo-card-background, ${({ theme }) => theme.colors.white});
  border-radius: var(--dcm-pbb-logo-card-border-radius, 20px);
  border: 1px solid var(--dcm-pbb-logo-card-border-color, ${({ theme }) => theme.colors.grey[95]});
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  padding: 6px;
  position: relative;
  z-index: 2;
`;

const LogoImageContainer = styled.div`
  align-items: center;
  border-radius: var(--dcm-pbb-logo-card-border-radius, 14px);
  border: 1px solid var(--dcm-pbb-logo-card-border-color, ${({ theme }) => theme.colors.grey[95]});
  box-sizing: border-box;
  display: flex;
  height: 100%;
  justify-content: center;
  min-height: 88px;
  min-width: 84px;
  padding: 12px 16px;
  width: 100%;
`;

const LogoImage = styled.img`
  max-height: 100%;
  max-width: 100%;
  object-fit: contain;
  width: 72px;
`;
